const SignInStatusEnum = {
  anonymous: "anonymous",
  authenticated: "authenticated",
  signedIn: "signed-in",
};

export { SignInStatusEnum };
